// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

/**
 * `QuestDB` write `data`.
 */
export class QuestDbSnapshot implements flatbuffers.IUnpackableObject<QuestDbSnapshotT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): QuestDbSnapshot {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsQuestDbSnapshot(
    bb: flatbuffers.ByteBuffer,
    obj?: QuestDbSnapshot,
  ): QuestDbSnapshot {
    return (obj || new QuestDbSnapshot()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsQuestDbSnapshot(
    bb: flatbuffers.ByteBuffer,
    obj?: QuestDbSnapshot,
  ): QuestDbSnapshot {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new QuestDbSnapshot()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  rowCount(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  flushLatencyMs(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  bufferFill(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  connectionStatus(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  static startQuestDbSnapshot(builder: flatbuffers.Builder) {
    builder.startObject(4);
  }

  static addRowCount(builder: flatbuffers.Builder, rowCount: number) {
    builder.addFieldInt32(0, rowCount, 0);
  }

  static addFlushLatencyMs(builder: flatbuffers.Builder, flushLatencyMs: number) {
    builder.addFieldInt32(1, flushLatencyMs, 0);
  }

  static addBufferFill(builder: flatbuffers.Builder, bufferFill: number) {
    builder.addFieldInt32(2, bufferFill, 0);
  }

  static addConnectionStatus(builder: flatbuffers.Builder, connectionStatus: boolean) {
    builder.addFieldInt8(3, +connectionStatus, +false);
  }

  static endQuestDbSnapshot(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createQuestDbSnapshot(
    builder: flatbuffers.Builder,
    rowCount: number,
    flushLatencyMs: number,
    bufferFill: number,
    connectionStatus: boolean,
  ): flatbuffers.Offset {
    QuestDbSnapshot.startQuestDbSnapshot(builder);
    QuestDbSnapshot.addRowCount(builder, rowCount);
    QuestDbSnapshot.addFlushLatencyMs(builder, flushLatencyMs);
    QuestDbSnapshot.addBufferFill(builder, bufferFill);
    QuestDbSnapshot.addConnectionStatus(builder, connectionStatus);
    return QuestDbSnapshot.endQuestDbSnapshot(builder);
  }

  unpack(): QuestDbSnapshotT {
    return new QuestDbSnapshotT(
      this.rowCount(),
      this.flushLatencyMs(),
      this.bufferFill(),
      this.connectionStatus(),
    );
  }

  unpackTo(_o: QuestDbSnapshotT): void {
    _o.rowCount = this.rowCount();
    _o.flushLatencyMs = this.flushLatencyMs();
    _o.bufferFill = this.bufferFill();
    _o.connectionStatus = this.connectionStatus();
  }

  unpackFields(...fields: string[]): QuestDbSnapshotT {
    const t = new QuestDbSnapshotT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("row_count")) {
      t.rowCount = this.rowCount();
    }
    if (fieldSet.has("flush_latency_ms")) {
      t.flushLatencyMs = this.flushLatencyMs();
    }
    if (fieldSet.has("buffer_fill")) {
      t.bufferFill = this.bufferFill();
    }
    if (fieldSet.has("connection_status")) {
      t.connectionStatus = this.connectionStatus();
    }
    return t;
  }
}

export class QuestDbSnapshotT implements flatbuffers.IGeneratedObject {
  constructor(
    public rowCount: number = 0,
    public flushLatencyMs: number = 0,
    public bufferFill: number = 0,
    public connectionStatus: boolean = false,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    return QuestDbSnapshot.createQuestDbSnapshot(
      builder,
      this.rowCount,
      this.flushLatencyMs,
      this.bufferFill,
      this.connectionStatus,
    );
  }

  clone(): QuestDbSnapshotT {
    const obj = new QuestDbSnapshotT();
    obj.rowCount = this.rowCount;
    obj.flushLatencyMs = this.flushLatencyMs;
    obj.bufferFill = this.bufferFill;
    obj.connectionStatus = this.connectionStatus;
    return obj;
  }

  equals(other: QuestDbSnapshotT): boolean {
    if (this.rowCount !== other.rowCount) return false;
    if (this.flushLatencyMs !== other.flushLatencyMs) return false;
    if (this.bufferFill !== other.bufferFill) return false;
    if (this.connectionStatus !== other.connectionStatus) return false;
    return true;
  }
}

export function verifyQuestDbSnapshot(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 4);
    verifier.checkScalarField(tablePos, 6, 4);
    verifier.checkScalarField(tablePos, 8, 4);
    verifier.checkScalarField(tablePos, 10, 1);
  } finally {
    verifier.popDepth();
  }
}
